export enum AccountType {
  OPERATOR = 'OPERATOR',
  FORWARDER = 'FORWARDER',
  SHIPPER = 'SHIPPER',
}
